import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgSeedsOutline = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 20 20"
    >
        <title>seeds outline</title>
        <path
            d="M14.5811 6.58301H17.5811V7.91699C17.581 9.15455 17.089 10.3417 16.2139 11.2168C15.3387 12.0919 14.1517 12.583 12.9141 12.583H10.0811V16.75H9.91406V11.6807L9.92871 10.877C10.0223 9.71018 10.551 8.62062 11.4102 7.8252C12.2728 7.02666 13.4056 6.58296 14.5811 6.58301ZM4.99805 3.25C6.06503 3.24973 7.10499 3.58529 7.9707 4.20898C8.70765 4.73992 9.2853 5.45732 9.64941 6.2832C9.11457 6.81315 8.66702 7.42608 8.32715 8.10059C8.01195 8.72619 7.79367 9.39484 7.67773 10.083H7.49707C6.14916 10.0829 4.85652 9.54776 3.90332 8.59473C2.95001 7.64142 2.41406 6.34818 2.41406 5V3.25H4.99805Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.2"
        />
    </svg>
);

export const SeedsOutlineIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgSeedsOutline}
        fontSize={fontSize}
    />
);
